export default "__VITE_ASSET__HAWlblZ6__"